<template>
    <button
        type="button"
        class="flex items-center rounded-full bg-gray-900 p-1 text-gray-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
        :title="isDark ? $t('theme.toLight') : $t('theme.toDark')"
        :aria-label="isDark ? $t('theme.toLight') : $t('theme.toDark')"
        @click="toggleTheme"
    >
        <span class="material-symbols-outlined">{{ isDark ? 'light_mode' : 'dark_mode' }}</span>
    </button>
</template>

<script>
import { useTheme } from '@/composables/useTheme';

// Light/dark switch. The choice is remembered in localStorage (see useTheme).
export default {
    setup() {
        const { isDark, toggleTheme } = useTheme();
        return { isDark, toggleTheme };
    },
};
</script>
